<template>
  <!-- 送り状作成シート表示 -->
  <div id="KenshinInvoiceSheetView">
    <div id="container">
      <div class="labelTitle lable">送り状シート表示</div>
      <div class="button-area">
        <div class="delivaryDay-area"><div>出荷日：</div><input type="date" id="delivaryDay" v-model="delivaryDay"><span class="require"/></div>
        <b-button class="clipboadCopyButton is-primary" @click="clipboardCopy">クリップボードにコピー</b-button>
        <b-button class="backButton is-primary" @click="back">戻る</b-button>
      </div>
      <div class="result-area">
        <table id="kenshinInvoiceSheetViewTable">
          <thead>
          <tr>
            <th width="60">出荷日</th>
            <th width="60">ステイタス</th>
            <th width="50">シリアル</th>
            <th width="80">管理番号</th>
            <th width="130">社員コード/拠点コード</th>
            <th width="300">得意先：企業/医療機関</th>
            <th width="200">事業所名</th>
            <th width="90">事業所郵便番号</th>
            <th width="250">事業所住所（発送先）</th>
            <th width="250">宛名</th>
            <th width="100">電話番号</th>
          </tr>
          </thead>
          <tbody id="kenshinInvoiceSheetViewTableBody">
          <tr v-for="(item, index) in data" :key="index">
            <td>{{delivaryDay | dayFilter}}</td><!-- 出荷日-->
            <td></td><!-- ステイタス-->
            <td></td><!-- シリアル-->
            <td>{{item.receptionNo}}</td><!-- 管理番号-->
            <td></td><!-- 社員コード/拠点コード-->
            <td>{{item.companyName}}</td><!-- 得意先：企業/医療機関-->
            <td>{{item.officeName}}</td><!-- 事業所名-->
            <td>{{item.deliveryZip}}</td><!-- 事業所郵便番号-->
            <td>{{item.deliveryAddress}}</td><!-- 事業所住所（発送先）-->
            <td>{{item.deliveryName2}}</td><!-- 宛名-->
            <td>{{item.deliveryPhoneNumber}}</td><!-- 電話番号-->
          </tr>
          </tbody>
        </table>
    　</div>
      <div class="button-area">
        <b-button class="backButton is-primary" @click="back">戻る</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import {choicesType} from "@/components/mock/base/const.js";

export default {
  name: "KenshinInvoiceSheetView",
  methods: {
    back: function () {
      this.$router.push({
        name: "KenshinShippingList",
        params: { searchConditions: this.searchParams },
      });
    },
    clipboardCopy: function() {
      if(!delivaryDay.value){
        this.showMessage('出荷日を指定してください。');
      } else {
        var table = document.getElementById('kenshinInvoiceSheetViewTableBody');
        navigator.clipboard.writeText(table.innerText).then(() => {
          this.showMessage('クリップボードにコピーしました。');
        }).catch(err => {
          this.showMessage('コピーに失敗しました');
          console.log(err);
        });
      }
    },
    hasBattery: function(modelId) {
      var rtnName = ""
      var device = this.kenshinDeviceList.find(item => item.value==modelId)
      if(device && device.label1.indexOf("PULSOX") < 0){
        rtnName = "リチウムイオンバッテリー内蔵機器"
      }
      return rtnName
    },
    doSearch: function() {
      var excuteApi = this.getKenshinInvoiceSheetPOST;
      var successCallBack = this.getKenshinInvoiceSheetPOSTSuccess;
      var errorCallBack = this.getKenshinInvoiceSheetPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getKenshinInvoiceSheetPOST: function(client) {
      return client.apis.internalKenshin.getKenshinInvoiceSheetPOST({
        body:{receiptNumber:this.targetNumber}
      });
    },
    getKenshinInvoiceSheetPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
    },
    getKenshinInvoiceSheetPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result,this.back());
    }
  },
  data() {
    var targetNumber = this.$route.params["receiptNumber"];
    var searchParams = this.$route.params["searchConditions"];
    var kenshinDeviceList = this.getChoiceList(choicesType.kenshinDevice, false);
    return {
      targetNumber,
      searchParams,
      delivaryDay: "",
      data: [],
      kenshinDeviceList
    };
  },
  async mounted() {
    // 機種マスタ取得
    await this.doSearch();
  },
  filters: {
    dayFilter: function(value){
      return value ? value.replaceAll('-', '/'): "";
    }
  },
  components: {}
};
</script>
<style lang="scss" scoped>
.result-area {
  margin-top: 20px;
  width:1400px;
  max-height: 650px;
  overflow: scroll;
}
.delivaryDay-area {
  float:left;
  margin-right:10px;
}
.delivaryDay-area div{
  float:left;
}
#delivaryDay {
  width: 150px;
  float:left;
}
#kenshinInvoiceSheetViewTable {
  width: 1570px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/kenshin/shipping/KenshinInvoiceSheetView.vue